import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../../shared/utility';

const initialState = {
    documents: [],
    loading: false
};

const fetchDocumentsStart = ( state, action ) => {
    return updateObject( state, { loading: true } );
};

const fetchDocumentsSuccess = ( state, action ) => {
    return updateObject( state, {
        documents: action.documents,
        loading: false
    } );
};

const fetchDocumentsFail = ( state, action ) => {
    return updateObject( state, { loading: false } );
};



const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_DOCUMENTS_START: return fetchDocumentsStart( state, action );
        case actionTypes.FETCH_DOCUMENTS_SUCCESS: return fetchDocumentsSuccess( state, action );
        case actionTypes.FETCH_DOCUMENTS_FAIL: return fetchDocumentsFail( state, action );
        default:
            return state;
    }
};

export default reducer;


// WEBPACK FOOTER //
// ./src/store/reducers/documents.js